import React from "react";

import PopUp from "./components/PopUp";

process.env.REACT_APP_ENDPOINT 

const dlBtn = (props) => (
  <PopUp
    infoResponse={props.infoResponse}
    canvasLabel={props.canvasLabel}
    canvases={props.canvases}
    manifestUrl={props.manifestUrl}
    manifest={props.manifest}
    t={props.t}
  />
);

export default dlBtn;